// @ts-strict

import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-global-checkbox',
  templateUrl: './global-checkbox.component.html',
  styleUrls: ['./global-checkbox.component.scss']
})
export class GlobalCheckboxComponent implements OnInit, OnChanges {
  @Input() controlled = false;
  @Input() uncheckedGray = false;
  @Input() smallCheckbox = false;
  @Input() submitted = false;
  @Input() disabled = false;
  @Input() required = false;
  @Input() checked = false;
  @Input() translateText = true;
  @Input() additionalClass?: string;
  @Input() checkBoxIcon?: string;
  @Input() checkBoxSize?: string;
  @Input() tooltipText?: string;
  @Input() paddingLeft?: string;
  @Input() fontWeight?: string;
  @Input() fontSize?: string;
  @Input() text?: string;
  @Input() size?: string;
  @Input() id?: string;
  @Input() fontColor?: string;

  @Output() emitChange = new EventEmitter<boolean>();

  public checkboxAccepted = false;

  ngOnInit(): void {
    this.checkboxAccepted = this.checked;
  }

  ngOnChanges(): void {
    this.checkboxAccepted = this.checked;
  }

  public toggleCheckbox(): void {
    if (this.disabled) return;

    if (!this.controlled) this.checkboxAccepted = !this.checkboxAccepted;

    this.emitChange.emit(this.checkboxAccepted);
  }
}
